import browserHistory from './browserHistory';
import configureStore from './configureStore';
import { loadState } from './localStorage';

export function makeStore(initialState) {
  return configureStore(process.env.NODE_ENV, browserHistory, initialState);
}

export const store = makeStore(loadState());
